import * as THREE from "three";

export default function(x, y, z, size, camera, textureLoader) {
  Object.setPrototypeOf(this, new THREE.Object3D());
  this.position.set(x, y, z);
  this.name = "Background";

  const textureBottom = textureLoader.load("/img/3DTextures/memoram/game/backgroundBottom.jpg");
  const textureLateral = textureLoader.load("/img/3DTextures/memoram/game/backgroundSide.jpg");
  const textureFrontal = textureLoader.load("/img/3DTextures/memoram/game/backgroundSide.jpg");
  textureFrontal.wrapS = THREE.RepeatWrapping;
  textureFrontal.repeat.x = -1;
  const textureTop = textureLoader.load("/img/3DTextures/memoram/game/backgroundTop.jpg");

  const materialBottom = new THREE.MeshBasicMaterial({ map: textureBottom });
  const materialLateral = new THREE.MeshBasicMaterial({ map: textureLateral });
  const materialFrontal = new THREE.MeshBasicMaterial({ map: textureFrontal });
  const materialTop = new THREE.MeshBasicMaterial({ map: textureTop });

  const geometry = new THREE.BoxBufferGeometry(size, size, size);
  const material = [
    materialLateral,
    materialLateral,
    materialTop,
    materialBottom,
    materialFrontal,
    materialFrontal
  ];

  const mesh = new THREE.Mesh(geometry, material);
  mesh.geometry.scale(1, 1, -1);

  this.add(mesh);

  let cameraPosition = 0;
  let moveRatio = 0.01;

  /*
   * @function - perform
   * Action of agents oriented programming 3d interfaces
   * @param - scene (ThreeJS Scene Instance): Scene instance of the 3d scene
   */
  function perform() {
    if (cameraPosition !== camera.position.x) {
      if (this.rotation.x > 10 || this.rotation.x < -10) {
        moveRatio = -moveRatio;
      }
      this.rotation.x -= moveRatio;
      this.rotation.y += moveRatio / 2;

      cameraPosition = camera.position.x;
    }
  }

  this.perform = perform;
}
